import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Siempre pensé que RRHH no era para mí. Este material me ayudó a entender cómo usar mi formación en otro contexto.',
    name: 'Sofía, 28 años',
    role: 'Psicóloga'
  }, {
    quote: 'No sabía por dónde empezar. Hoy tengo un CV claro y estoy teniendo entrevistas.',
    name: 'Lucas, 32 años',
    role: 'Psicólogo'
  }, {
    quote: 'Me cambió la forma de ver mi carrera. Ya no siento que solo tengo una opción.',
    name: 'Mariana, 30 años',
    role: 'Psicóloga'
  }];
  return <section className="py-12 md:py-20 bg-slate-50" data-id="element-138">
      <div className="max-w-6xl mx-auto px-4" data-id="element-139">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-140">
          LO QUE ESTÁN LOGRANDO OTROS PROFESIONALES
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-141">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all" data-id="element-142">
              <QuoteIcon className="w-10 h-10 text-amber-500 mb-4" data-id="element-143" />
              <p className="text-gray-700 mb-6 italic" data-id="element-144">"{testimonial.quote}"</p>
              <div className="border-t border-gray-200 pt-4" data-id="element-145">
                <p className="font-bold text-gray-900" data-id="element-146">{testimonial.name}</p>
                <p className="text-sm text-gray-600" data-id="element-147">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}